import type { SubscriptionStatus } from "../types";

export { normalizePaystackStatus } from "../processor/paystack/normalize";
export { normalizePolarStatus } from "../processor/polar/normalize";

/**
 * Returns true if the subscription status grants platform access.
 * 'active' and 'non_renewing' both allow access — the user is paid up
 * and the subscription is still within its billing period.
 * 'attention' allows access but requires payment update.
 */
export function isSubscriptionAccessible(status: SubscriptionStatus): boolean {
  return (
    status === "active" || status === "non_renewing" || status === "attention"
  );
}
